import {
  UpdateRiskCategoryInput,
  CreateRiskCategoryInput,
} from "../validation/risk_category";
import authService from "./authService";

let BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || process.env.REACT_APP_API_URL || "";

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch {
    // Use default BASE_URL from env
  }
}
loadConfig().then(() => {});



export async function getCategory() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/question-categories/all`, {
      method: 'GET',
    
    });

    if (!response.ok) {
      throw new Error('Failed to get category');
    }

    const result = await response.json();
    //console.log('category fetched successfully:', result);
    return result;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
}

export async function fetchDataApi(
  url: string,
  options: RequestInit = {}
): Promise<any> {
  const response = await authService.apiCall(`${BASE_URL}/${url}`, {
    ...options,
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (
      response.status === 401 ||
      response.status === 403 ||
      data.message === "Forbidden access"
    ) {
      throw new Error(
        "Forbidden: You do not have permission to access this resource."
      );
    }
    throw new Error("Failed to fetch");
  }
  return data;
}

export async function fetchAllDataApi(): Promise<any> {
  const response = await authService.apiCall(`${BASE_URL}/categories/getAll`, {
    method: "GET",
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (
      response.status === 401 ||
      response.status === 403 ||
      data.message === "Forbidden access"
    ) {
      throw new Error(
        "Forbidden: You do not have permission to access this resource."
      );
    }
    throw new Error("Failed to fetch");
  }
  return data;
}

export async function createCategoryApi(
  body: CreateRiskCategoryInput
): Promise<void> {
  const response = await authService.apiCall(`${BASE_URL}/categories`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (
      response.status === 401 ||
      response.status === 403 ||
      data.message === "Forbidden access"
    ) {
      throw new Error(
        "Forbidden: You do not have permission to access this resource."
      );
    }
    throw new Error("Failed to create");
  }
  return data;
}

export async function updateCategoryApi(
  id: string,
  body: UpdateRiskCategoryInput
): Promise<void> {
  const response = await authService.apiCall(`${BASE_URL}/categories/${id}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (
      response.status === 401 ||
      response.status === 403 ||
      data.message === "Forbidden access"
    ) {
      throw new Error(
        "Forbidden: You do not have permission to access this resource."
      );
    }
    throw new Error("Failed to update");
  }
  return data;
}

export async function deleteCategoryApi(id: string): Promise<void> {
  const response = await authService.apiCall(`${BASE_URL}/categories/${id}`, {
    method: "DELETE",
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (
      response.status === 401 ||
      response.status === 403 ||
      data.message === "Forbidden access"
    ) {
      throw new Error(
        "Forbidden: You do not have permission to access this resource."
      );
    }
    throw new Error("Failed to delete");
  }
  return data;
}

export async function getCatCount(): Promise<any> {
  const response = await authService.apiCall(
    `${BASE_URL}/categories/count`,
    { method: "GET" }
  );
  const data = await response.json();
  if (!response.ok || !data.success) {
    if (
      response.status === 401 ||
      response.status === 403 ||
      data.message === "Forbidden access"
    ) {
      throw new Error(
        "Forbidden: You do not have permission to access this resource."
      );
    }
    throw new Error("Failed to fetch");
  }
  return data;
}
